import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useApp } from "@/AppContext";
import AuthPage from "@/pages/AuthPage";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import AdminPanel from "@/pages/AdminPanel";
import AdminLogin from "@/pages/AdminLogin";
import { FuturisticFrame } from "@/components/FuturisticFrame";

function Loading() {
  return (
    <div className="min-h-screen ps-grid-bg flex items-center justify-center">
      <div className="font-display ps-neon-text text-2xl animate-pulse">PARTSPARE</div>
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user } = useApp();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AdminRoute() {
  const { user } = useApp();
  if (user === null) return <Loading />;
  if (user && user.role === "admin") return <AdminPanel />;
  return <AdminLogin />;
}

function App() {
  const { user } = useApp();
  return (
    <BrowserRouter>
      <div className="ps-shell">
        <FuturisticFrame />
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin" element={<AdminRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
